<template>
  <div class="control-box">
    <div class="row align-items-center list-control">
      <div v-if="!onlySearch" class="col-sm-12 col-sm-9 flex">
        <b-row class="control">
          <!-- <div class="col-6 col-sm-4 col-md-2">
            <find-button @click="$emit('doFind')"></find-button>
          </div> -->
          <div v-if="showAdd && (!permission || $permission(permission.create))" class="col-6 col-md-4">
            <add-button @click="$emit('doAddNew')">
              <template> (A) </template>
            </add-button>
          </div>
          <div v-if="showEdit && (!permission || $permission(permission.edit))" class="col-6 col-md-4">
            <edit-button :disabled="disabled.edit" :countChecked="countChecked" @click="$emit('doEdit')">
              <template> (E) </template>
            </edit-button>
          </div>
          <div v-if="showPrint && (!permission || $permission(permission.print))" class="col-6 col-md-4">
            <print-button
              :disabled="disabled.print"
              :countChecked="countChecked"
              @print="$emit('print')"
              @printAll="$emit('printAll')"
            ></print-button>
          </div>
          <!-- <div
            v-if="!permission || $permission(permission.export)"
            class="col-6 col-sm-4 col-md-2"
          >
            <export-button
              @exportExcel="$emit('exportExcel')"
              @exportPdf="$emit('exportPdf')"
              :countChecked="countChecked"
            ></export-button>
          </div> -->
          <div class="col-12  col-md-4" v-if="showOption && (!permission || $permission(permission.option))">
            <option-button
              :permission="permission"
              @copy="$emit('copy')"
              @doDelete="$emit('doDelete')"
              :help="help"
              :countChecked="countChecked"
            ></option-button>
          </div>
          <slot name="control"> </slot>
        </b-row>
      </div>
      <div class="col-sm-12 col-sm-3 text-right" v-if="!noSearch">
        <div class="row search">
          <base-input
            class="input-group-alternative mb-0 text-right"
            placeholder="Nhập nội dung để tìm..."
            addon-left-icon="fa fa-search"
            v-model="keyword"
          ></base-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'control-panel',
  props: {
    onlySearch: {
      type: Boolean,
      default: false
    },
    showPrint: {
      type: Boolean,
      default: false
    },
    showEdit: {
      type: Boolean,
      default: true
    },
    showAdd: {
      type: Boolean,
      default: true
    },
    showOption: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Object,
      default: () => {
        return {
          edit: false,
          print: false
        };
      }
    },
    permission: {
      type: Object
    },
    help: {
      type: Function
    },
    countChecked: {
      type: Number,
      required: true
    },
    noSearch: {
      default: false
    }
  },
  data() {
    return {
      keyword: '',
      timerSearch: null
    };
  },
  watch: {
    keyword: function() {
      clearTimeout(this.timerSearch);
      this.timerSearch = setTimeout(() => {
        this.$emit('search', this.keyword);
      }, 500);
    }
  }
};
</script>

<style scoped lang="scss">
.search {
  margin-top: 1px;
  padding: 0 10px;
}
</style>
